import { Explore } from '@mui/icons-material'
import React from 'react'

// MUI's SvgIcon sets its own `width: 1em; height: 1em` CSS class, which
// overrides the width="100%"/height="100%" attributes GenericSvgIcon passes
// to every svgComponent — a CSS class always beats a plain SVG presentation
// attribute. `fontSize="small"` is MUI's 20px preset, matching
// NavIconWrapper's 20x20 slot exactly, same convention already used in
// HeaderFilterPanel.tsx (`<TuneOutlined fontSize={'small'} />`).
const ExploreSvgIcon: React.FC = () => <Explore fontSize="small" />

export default ExploreSvgIcon
